export enum Quadrant {
  Zero,
  One,
  Two,
  Three,
}
